import { transformImage } from '@/helpers/transforms'
import type { StaffBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { hasText } from '@payloadcms/richtext-lexical/shared'
import type { CardProfileType } from '../atoms/CardProfile'
import { CMSBlocks } from '../atoms/CMSBlocks'
import { TeamBlock } from '../blocks/TeamBlock'

export const StaffConverter: JSXConverter<SerializedBlockNode<StaffBlock>> = ({
	node,
	nodesToJSX,
}) => {
	const { staff } = node.fields

	const profiles: CardProfileType[] = staff.map((member) => {
		const imageData = transformImage(member.photo)
		return {
			name: member.name,
			image: imageData,
			position: member.position,
			hasDetails: hasText(member.bio),
			details: <CMSBlocks>{nodesToJSX({ nodes: member.bio?.root?.children ?? [] })}</CMSBlocks>,
		}
	})

	return <TeamBlock team={profiles} />
}
